import styled from 'styled-components';

export const FirmNameStyles = styled.div`
  color: ${({ theme }) => theme.colors.color_bluegray};
  flex-shrink: 1;
  max-width: 200px;
  a {
    color: ${({ theme }) => theme.colors.color_blue};

    &:hover {
      text-decoration: underline;
    }
  }

  max-width: ${({ mw }) => mw};

  @media screen and (max-width: 1023px) {
    order: 5;
    max-width: 200px;
    padding-top: 7px;
  }

  @media screen and (max-width: 768px) {
    max-width: 200px;
  }

  @media screen and (max-width: 639px) {
    max-width: 135px;
  }
`;
